//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets all templates.
 * @return List with all folders of the user.
 */
export function getCalculationTemplates(config?: AxiosRequestConfig | undefined): Promise<Types.CalculationTemplateDto[]> {
    let url_ = getBaseUrl() + "/api/calculation-templates";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCalculationTemplates,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCalculationTemplates?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCalculationTemplates(_response);
    });
}

function processGetCalculationTemplates(response: AxiosResponse): Promise<Types.CalculationTemplateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initCalculationTemplateDto(item)
              );
            }
        return Promise.resolve<Types.CalculationTemplateDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CalculationTemplateDto[]>(null as any);
}
let _requestConfigGetCalculationTemplates: Partial<AxiosRequestConfig> | null;
export function getGetCalculationTemplatesRequestConfig() {
  return _requestConfigGetCalculationTemplates;
}
export function setGetCalculationTemplatesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCalculationTemplates = value;
}
export function patchGetCalculationTemplatesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCalculationTemplates = patch(_requestConfigGetCalculationTemplates ?? {});
}